import * as ROUTES from './routes'
import * as USER_TYPES from './user-types'

export default [
  {
    component: 'Home',
    exact: false,
    href: ROUTES.HOME,
    navName: 'Home',
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: true
  },
  {
    component: 'UserManagement',
    exact: false,
    href: ROUTES.USER_MANAGEMENT,
    navName: 'Users',
    onlyAdmin: true,
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'ArticleManagement',
    exact: false,
    href: ROUTES.ARTICLE_MANAGEMENT,
    navName: 'Articles',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'SiteManagement',
    exact: false,
    href: ROUTES.SITE_MANAGEMENT,
    navName: 'Sites',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'CategoryManagement',
    exact: false,
    href: ROUTES.CATEGORY_MANAGEMENT,
    navName: 'Categories',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'DatasetManagement',
    exact: false,
    href: ROUTES.DATASET_MANAGEMENT,
    navName: 'DataSets',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'DiscoveryManagement',
    exact: false,
    href: ROUTES.DISCOVERY_MANAGEMENT,
    navName: 'Discovery',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'HelpManagement',
    exact: false,
    href: ROUTES.HELP_MANAGEMENT,
    navName: 'Help',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'InsightManagement',
    exact: false,
    href: ROUTES.INSIGHT_MANAGEMENT,
    navName: 'Insights',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'TagManagement',
    exact: false,
    href: ROUTES.TAG_MANAGEMENT,
    navName: 'Tags',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'WebpageManagement',
    exact: false,
    href: ROUTES.WEBPAGE_MANAGEMENT,
    navName: 'Web Pages',
    permissions: [USER_TYPES.ADMIN],
    renderInNav: true
  },
  {
    component: 'PreviewArticles',
    exact: true,
    href: ROUTES.PREVIEW_ARTICLES,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Article',
    exact: true,
    href: ROUTES.ARTICLE,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Discovery',
    exact: true,
    href: ROUTES.DISCOVERY,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Webpage',
    exact: true,
    href: ROUTES.WEBPAGE,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Help',
    exact: false,
    href: ROUTES.HELP,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'SearchResults',
    exact: false,
    href: ROUTES.SEARCH_RESULTS,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'LatestPosts',
    exact: false,
    href: ROUTES.LATEST_POSTS,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Site',
    exact: false,
    href: ROUTES.SITE,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  },
  {
    component: 'Unauthorised',
    exact: false,
    href: ROUTES.UNAUTHORISED,
    permissions: [USER_TYPES.ADMIN, USER_TYPES.SUPER, USER_TYPES.GENERAL],
    renderInNav: false
  }
]
